var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTiff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.371 4.571C7.371 3.151 8.502 2 9.897 2H25.05a.85.85 0 01.842.857.85.85 0 01-.842.857H9.897a.85.85 0 00-.842.857V20a.85.85 0 01-.842.857.85.85 0 01-.842-.857V4.57zm27.783 7.715a.85.85 0 01.842.857v13.714a.85.85 0 01-.842.857.85.85 0 01-.842-.857V13.143a.85.85 0 01.842-.857zm0 18.857a.85.85 0 01.842.857v3.429c0 1.42-1.131 2.571-2.526 2.571H11.58a.85.85 0 01-.841-.857.85.85 0 01.841-.857h21.89a.85.85 0 00.842-.857v-3.43a.85.85 0 01.842-.856z",
    fill: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.73 2.065a.831.831 0 01.918.186l10.103 10.286c.241.245.313.614.183.934a.841.841 0 01-.778.529h-8.42c-1.394 0-2.525-1.151-2.525-2.572v-8.57c0-.347.205-.66.52-.792zm1.165 2.861v6.502a.85.85 0 00.842.858h6.387l-7.229-7.36z",
    fill: "#ED1B2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.012 24.469V33H6.26v-8.531h1.752zm2.625 0v1.377H3.676v-1.377h6.96zm2.87 0V33h-1.751v-8.531h1.752zm3.405 0V33h-1.758v-8.531h1.758zm3.399 3.644v1.371h-3.88v-1.37h3.88zm.41-3.644v1.377h-4.29v-1.377h4.29zm2.777 0V33H21.74v-8.531h1.758zm3.398 3.644v1.371h-3.878v-1.37h3.878zm.41-3.644v1.377h-4.288v-1.377h4.289z",
    fill: "#ED1B2E"
  })));
}

export default SvgIconTiff;